// Ops demo data layer: in-memory state for one tab session (a reload resets it).

import { resetCatalog } from './catalog';
import { resetFleet } from './fleet';
import { resetNetwork } from './network';
import { resetNotifications } from './notifications';
import { resetOrders } from './orders';
import { resetPeople } from './people';
import { resetSchedule } from './schedule';
import { resetSites } from './sites';
import { resetUploads } from './uploads';
import { resetPreOrders } from './views';

let ready = false;

/** Rebuild every fixture from the core story (order matters: orders price from agreements). */
export function resetDemoData(): void {
  resetCatalog();
  resetPeople();
  resetSites();
  resetFleet();
  resetNetwork();
  resetSchedule();
  resetUploads();
  resetOrders();
  resetPreOrders();
  resetNotifications();
  ready = true;
}

/** Lazily build the fixtures the first time the demo API is used. */
export function ensureDemoData(): void {
  if (!ready) resetDemoData();
}

export { demoOrganizationFor } from './people';
